import React, { useState } from 'react';
import { MdArrowBack, MdCameraAlt, MdSwapHoriz } from 'react-icons/md';
import { FaRegCreditCard } from 'react-icons/fa';
import accountsData from '../data/accounts.json';
import txData from '../data/transactions.json';
import { useApp, maskAmount } from '../contexts/AppContext';

const creditDataSummary = accountsData.creditDataSummary;
const transactionsData = txData.transactionsData;

const CreditScreen = ({ onNavigate, onBack }) => {
  const creditCard = creditDataSummary[0];
  const { hideBalances } = useApp();
  const [tab, setTab] = useState('activity');

  return (
    <div className="screen credit-screen">
      <div className="scroll-content account-details-scroll">
        <header className="bh-flow-hero dark">
          <div className="bh-flow-hero-left">
            <button className="bh-flow-back" onClick={onBack || (() => onNavigate('accounts'))} aria-label="Back to accounts">
              <MdArrowBack />
            </button>
            <h1 className="bh-flow-title">Credit</h1>
          </div>
        </header>

        <div className="account-details-content">
        {/* Card balance + pagination + actions */}
        <div className="bh-form-card">
          <div className="bh-hero-card-balance">
            <span className="bh-hero-card-eyebrow">Current Balance</span>
            <h2 className="bh-hero-card-amount">{maskAmount(String(creditCard.balance || '').replace(/\.\d{2}$/, ''), hideBalances)}</h2>
            <p style={{ margin: 'var(--space-3xs) 0 0', font: 'var(--bh-body-sm)', color: 'var(--bh-gray)' }}>
              {creditCard.name}
            </p>
          </div>

          <div className="bh-dots" aria-hidden="true">
            <span className="bh-dot active" />
            <span className="bh-dot" />
            <span className="bh-dot" />
            <span className="bh-dot" />
          </div>

          <div className="bh-action-row">
            <button className="bh-action-card">
              <div className="bh-action-card-icon"><FaRegCreditCard /></div>
              <span>Pay</span>
            </button>
            <button className="bh-action-card" onClick={() => onNavigate('emailTransfer')}>
              <div className="bh-action-card-icon"><MdSwapHoriz /></div>
              <span>Transfer</span>
            </button>
            <button className="bh-action-card">
              <div className="bh-action-card-icon"><MdCameraAlt /></div>
              <span>Deposit</span>
            </button>
          </div>
        </div>

        {/* Activity / Details tabs */}
        <div className="bh-tabs" role="tablist">
          <button
            role="tab"
            aria-selected={tab === 'activity'}
            className={`bh-tab${tab === 'activity' ? ' active' : ''}`}
            onClick={() => setTab('activity')}
          >
            Activity
          </button>
          <button
            role="tab"
            aria-selected={tab === 'details'}
            className={`bh-tab${tab === 'details' ? ' active' : ''}`}
            onClick={() => setTab('details')}
          >
            Details
          </button>
        </div>

        {tab === 'activity' && (
          <div className="bh-tx-list" role="tabpanel">
            {transactionsData.map((group, index) => (
              <React.Fragment key={index}>
                <div className="bh-tx-group-title">{group.dateGroup}</div>
                {group.items.map(item => (
                  <div key={item.id} className="bh-tx-row">
                    <div className="bh-tx-row-info">
                      <span className="bh-tx-merchant">{item.merchant}</span>
                    </div>
                    <span className={`bh-tx-amount${item.isPositive ? ' positive' : ''}`}>
                      {item.amount}
                    </span>
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        )}

        {tab === 'details' && (
          <div className="bh-form-card" role="tabpanel">
            <h3 style={{ margin: 0, font: 'var(--bh-h3)', color: 'var(--bh-black)' }}>Card Details</h3>
            <div className="bh-review-rows">
              <div className="bh-review-row">
                <span className="bh-review-row-label">Card</span>
                <span className="bh-review-row-value">{creditCard.name}</span>
              </div>
              {creditCard.number && (
                <div className="bh-review-row">
                  <span className="bh-review-row-label">Number</span>
                  <span className="bh-review-row-value">{creditCard.number}</span>
                </div>
              )}
              <div className="bh-review-row">
                <span className="bh-review-row-label">Balance</span>
                <span className="bh-review-row-value">{creditCard.balance}</span>
              </div>
              {creditCard.creditLimit && (
                <div className="bh-review-row">
                  <span className="bh-review-row-label">Credit Limit</span>
                  <span className="bh-review-row-value">{creditCard.creditLimit}</span>
                </div>
              )}
              {creditCard.dueDate && (
                <div className="bh-review-row">
                  <span className="bh-review-row-label">Due</span>
                  <span className="bh-review-row-value">{creditCard.dueDate}</span>
                </div>
              )}
            </div>
          </div>
        )}
        </div>{/* /.account-details-content */}
      </div>{/* /.scroll-content */}
    </div>
  );
};

export default CreditScreen;
